import { ConfigurationT, HeaderItem, ItemOrHeader } from 'components/ui-new/customization-configuration-popup/types';

export const getListWithHeaders = (list: ConfigurationT[], count: number, skipEmptyHeaders = false): ItemOrHeader[] => {
  const result: ItemOrHeader[] = [];

  const shownItems = list.filter((item) => item.is_shown);
  const hiddenItems = list.filter((item) => !item.is_shown);

  if (!skipEmptyHeaders || shownItems.length > 0) {
    result.push({
      id: 'header_shown',
      type: 'header',
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '4px', marginTop: '6px' }}>
          <span style={{ marginLeft: '10px' }}>Shown</span>
          <span style={{ marginRight: '10px' }}>{count}</span>
        </div>
      ),
    });
    result.push(...shownItems);
  }

  if (!skipEmptyHeaders || hiddenItems.length > 0) {
    result.push({
      id: 'header_hidden',
      type: 'header',
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '4px', marginTop: '6px' }}>
          <span style={{ marginLeft: '10px' }}>Hidden</span>
        </div>
      ),
    });
    result.push(...hiddenItems);
  }

  return result;
};

export const isHeaderItem = (item: ItemOrHeader): item is HeaderItem => {
  return 'type' in item && item.type === 'header';
};

export const isAttributeItem = (item: ItemOrHeader): item is ConfigurationT => {
  return !('type' in item);
};

export const areIdsInSameOrder = (newList: ItemOrHeader[], currentList: ConfigurationT[]): boolean => {
  const newIds = newList.filter(isAttributeItem).map((item) => item.id);
  const currentIds = currentList.map((item) => item.id);

  return newIds.length === currentIds.length && newIds.every((id, i) => id === currentIds[i]);
};
